import { MyLensesLensStatus } from "../../gql-generated/types";

import {
    type LensActionsVisibilityState,
    defaultShowWithDisabledConfig,
    disabledShowWithDisabledConfig,
    hiddenShowWithDisabledConfig,
} from "./LensActionsVisibilityState";

const {
    LensStatusLive,
    LensStatusHidden,
    LensStatusOffline,
    LensStatusInReview,
    LensStatusAwaitingProductTagging,
    LensStatusInvalid,
    LensStatusRejected,
    LensStatusNotPublishedToSnapchat,
    LensStatusProcessing,
    LensStatusAvailable,
    LensStatusFinalized,
    LensStatusFinalizing,
    LensStatusReady,
} = MyLensesLensStatus;

export const ERROR_STATUSES = new Set([LensStatusInvalid, LensStatusRejected]);

export const CAN_NOT_EDIT_STATUSES = new Set([
    LensStatusReady,
    LensStatusFinalized,
    LensStatusFinalizing,
    LensStatusRejected,
    LensStatusInvalid,
]);

export const SPONSORED_STATUSES = new Set([
    LensStatusReady,
    LensStatusFinalized,
    LensStatusFinalizing,
    LensStatusAwaitingProductTagging,
]);

// can't edit or update
export const LOCKED_BASE_STATUSES = new Set([
    LensStatusProcessing,
    LensStatusInReview,
    LensStatusAwaitingProductTagging,
]);

export const allFalseConfig: LensActionsVisibilityState = {
    deleteLens: false,
    downloadQrCode: false,
    copyDeeplink: false,
    setTags: false,
    setVisibility: false,
    setPreview: false,
    setLensCta: false,
    setLensCategory: false,
    manageDigitalGoods: false,
    finalize: false,
    enrollCreatorPayout: hiddenShowWithDisabledConfig,
    publishToSnapchatConfig: hiddenShowWithDisabledConfig,
    setLensDescription: false,
    deleteHostedWebAr: false,
    generateHostedWebAr: false,
};

export const DESTINATION_BASED_LIVE_STATUSES = new Set([LensStatusLive, LensStatusOffline, LensStatusHidden]);

export const makeLensActionsConfigBasedOnStatus = (status: MyLensesLensStatus): LensActionsVisibilityState => {
    switch (status) {
        case LensStatusNotPublishedToSnapchat:
        case LensStatusAvailable:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                deleteLens: true,
                setTags: true,
                setLensCta: true,
                setLensCategory: true,
                setVisibility: true,
                setPreview: true,
                manageDigitalGoods: true,
                enrollCreatorPayout: defaultShowWithDisabledConfig,
                publishToSnapchatConfig: defaultShowWithDisabledConfig,
                setLensDescription: true,
                deleteHostedWebAr: true,
                generateHostedWebAr: true,
            };
        case LensStatusLive:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                deleteLens: true,
                setTags: true,
                setVisibility: true,
                setLensCta: true,
                setLensCategory: true,
                setPreview: true,
                manageDigitalGoods: true,
                enrollCreatorPayout: defaultShowWithDisabledConfig,
                setLensDescription: true,
                deleteHostedWebAr: true,
                generateHostedWebAr: true,
            };
        case LensStatusHidden:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                deleteLens: true,
                setTags: true,
                setVisibility: true,
                setLensCta: true,
                setLensCategory: true,
                setPreview: true,
                manageDigitalGoods: true,
                enrollCreatorPayout: defaultShowWithDisabledConfig,
                setLensDescription: true,
                deleteHostedWebAr: true,
                generateHostedWebAr: true,
            };
        case LensStatusOffline:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                deleteLens: true,
                setTags: true,
                setVisibility: true,
                setPreview: true,
                setLensCta: true,
                setLensCategory: true,
                manageDigitalGoods: true,
                enrollCreatorPayout: defaultShowWithDisabledConfig,
                setLensDescription: true,
                deleteHostedWebAr: true,
                generateHostedWebAr: true,
            };
        case LensStatusInReview:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                enrollCreatorPayout: disabledShowWithDisabledConfig,
            };
        case LensStatusAwaitingProductTagging:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
            };
        case LensStatusProcessing:
            return {
                ...allFalseConfig,
                downloadQrCode: true,
                copyDeeplink: true,
                deleteLens: true,
                enrollCreatorPayout: disabledShowWithDisabledConfig,
            };
        case LensStatusInvalid:
            return {
                ...allFalseConfig,
                deleteLens: true,
                enrollCreatorPayout: disabledShowWithDisabledConfig,
            };
        case LensStatusRejected:
            return {
                ...allFalseConfig,
                deleteLens: true,
                enrollCreatorPayout: disabledShowWithDisabledConfig,
            };
        default:
            return allFalseConfig;
    }
};
